import React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { Form } from '@hrlogics/react-components/form';

import { appRoutes } from '@clearverify/constants';

import { Button } from 'src/components/common';
import { useScreenInfo } from 'src/hooks/common';
import { useInboxFilter } from 'src/hooks/inboxItem';

import { InboxFilterFields } from './InboxFilterFields';
import { InboxFilterFormValues } from './types';
import { isInboxFormFilterEmpty } from './utils';

interface InboxFilterForm {
  onClose: () => void;
}

export const InboxFilterForm: React.FC<InboxFilterForm> = ({ onClose }) => {
  const navigate = useNavigate();
  const { isMobile } = useScreenInfo();

  const { filterFormValues, setFilterFormValues } = useInboxFilter();

  const handleSubmit = React.useCallback(
    (data: InboxFilterFormValues) => {
      setFilterFormValues(data);
      onClose();
      navigate(appRoutes.inbox.index);
    },
    [navigate, onClose, setFilterFormValues],
  );

  return (
    <Form<InboxFilterFormValues>
      onSubmit={handleSubmit}
      initialValues={filterFormValues}
      subscription={{ submitting: true, values: true }}
    >
      {({ form: { reset }, values, submitting }) => {
        const isInboxFilterEmpty = isInboxFormFilterEmpty(values);

        return (
          <Stack gap={2} px={3} py={2} sx={{ width: isMobile ? '100%' : '540px' }}>
            <Box
              data-e2e-element="filter-popup"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ height: '36px' }}
            >
              <Typography variant="body1">Filter by</Typography>
              {!isInboxFilterEmpty ? (
                <Button color="error" onClick={() => reset({})} disabled={submitting}>
                  Clear All
                </Button>
              ) : null}
            </Box>

            <Stack gap={3}>
              <InboxFilterFields disabled={submitting} />
            </Stack>

            <Box gap={2} display="flex" justifyContent="flex-end">
              <Button color="secondary" onClick={() => onClose()} disabled={submitting}>
                Cancel
              </Button>
              <Button type="submit" disabled={submitting}>
                Apply
              </Button>
            </Box>
          </Stack>
        );
      }}
    </Form>
  );
};
